import { useDispatch, useSelector } from "react-redux";
import React, { useRef } from "react";

import {
  GET_SURVEY_LIST,
  GET_SURVEY,
  GET_SECTION_LIST,
  SET_NO_FOUND,
  GET_PROJECT_LIST,
  GET_RESPONDER_LIST,
  SET_SUBMITTED,
  SET_PAGE,
  PATCH_USER,
  GET_ASSETS_LIST,
  SET_USERS,
  SET_MESSAGES,
  APPEND_MESSAGE,
  SET_CURRENT_MESSAGE,
  GET_BIO,
  GET_ROLE_LIST,
  GET_ACCOUNT_LIST,
} from "reducers/reducer";
import { getParameterByName } from "../common/helpers";
import { initialState } from "reducers/reducer";
import { pushNotification } from "utils/notifications";
import { useLocation } from "react-router-dom";
import { getPageRequestPublishTopic } from "hooks/MQTTConstants";
import { wrapRequestPayload } from "../helpers/request/RequestPayload";
import { SocketTopics } from "./../constants/enums";
import { RootState } from "reducers/rootReducer";
import moment from "moment";
import { useEffect } from "react";

export default () => {
  const { surveyId, requestIds } = useSelector(
    (state: RootState) => state.auth
  );

  const dispatch = useDispatch();
  const { search } = useLocation();
  const survetIdRef = useRef(null);

  useEffect(() => {
    if (surveyId) {
      survetIdRef.current = surveyId;
    }
  }, [surveyId]);

  // TODO:  Helper Functions - move to different file
  const getUserRequestPayload = (
    objectId: string,
    path: string = "$",
    returnPath: string = "$"
  ): IGetUserRequest => {
    return {
      objectId,
      paths: [path],
      returnPaths: [returnPath],
    };
  };

  const updateUserRequestPayload = (
    objectId: string,
    op: string,
    path: string = "$",
    value: any
  ): IUpdateUserRequest => {
    return {
      objectId,
      changes: [
        {
          op,
          path,
          value,
        },
      ],
    };
  };

  const updateUserRequestPayloadV2 = (
    objectId: string,
    changes: any[]
  ): IUpdateUserRequest => {
    console.log({
      objectId,
      changes: changes,
    });
    return {
      objectId,
      changes: changes,
    };
  };

  const getSectionList = (response) => {
    dispatch({ type: GET_SECTION_LIST, payload: response.data[0][0] });
  };

  const getBio = (response) => {
    dispatch({ type: GET_BIO, payload: response.data[0][0] });
  };
  const getRoleList = (response) => {
    dispatch({ type: GET_ROLE_LIST, payload: response.data[0][0] });
  };

  const getSurveyList = (response) => {
    const projectSurveyId = getParameterByName("surveyId")
      ? getParameterByName("surveyId")
      : survetIdRef.current;
    const isCreate = getParameterByName("mode") === "create";
    if (response.data) {
      let payload = {};
      if (projectSurveyId) {
        payload = response.data[0][0].find((el) => el._id == projectSurveyId);
        if (
          (!isCreate && payload == undefined) ||
          (payload &&
            Object.keys(payload).length === 0 &&
            Object.getPrototypeOf(payload) === Object.prototype)
        ) {
          dispatch({ type: SET_NO_FOUND, payload: true });
        }
      }
      if (
        !isCreate &&
        payload &&
        Object.keys(payload).length === 0 &&
        Object.getPrototypeOf(payload) === Object.prototype
      ) {
        payload = { ...initialState.survey };
      }
      const surveyId = getParameterByName("surveyId");
      if (!payload && surveyId && surveyId !== "") {
        payload = {
          _id: getParameterByName("surveyId"),
          name: "",
          questions: [],
        };
      }
      dispatch({ type: GET_SURVEY, payload });
      dispatch({ type: GET_SURVEY_LIST, payload: response.data[0][0] });
    }
  };

  const getExtendedBioList = (response) => {
    const surveyId = getParameterByName("surveyId");
    const question = response.data[0][0].find((el) => el._id === surveyId);
    if (!question) {
      dispatch({ type: SET_NO_FOUND, payload: true });
    }
    const survey = {
      _id: surveyId,
      name: question?.name || "",
      questions: question?.extendedBio || [],
      permissions: [],
    };
    dispatch({ type: GET_SURVEY, payload: survey });
    dispatch({ type: GET_SURVEY_LIST, payload: response.data[0][0] || [] });
  };

  const getVehicleExtendedBioList = (response) => {
    const question = response.data[0][0];
    if (!question) {
      dispatch({ type: SET_NO_FOUND, payload: true });
    }
    const survey = {
      _id: null,
      name: "Vehicle Extended Bio",
      questions: question || [],
      permissions: [],
    };
    dispatch({ type: GET_SURVEY, payload: survey });
    dispatch({ type: GET_SURVEY_LIST, payload: response.data[0][0] || [] });
  };

  const getProjectList = (response) => {
    dispatch({
      type: GET_PROJECT_LIST,
      payload: response?.data?.projects ?? [],
    });
  };

  const getAccountsList = (response) => {
    console.log("accounts", response?.data?.accounts);
    dispatch({
      type: GET_ACCOUNT_LIST,
      payload: response?.data?.accounts ?? [],
    });
  };

  const getRespondersList = (response) => {
    let responders = response?.data?.responders ?? [];
    if (responders.length === 0) {
      pushNotification(
        "No Responder available in the area",
        "error",
        "TOP_CENTER",
        1000
      );
    }
    dispatch({ type: GET_RESPONDER_LIST, payload: responders });
  };

  const getAssetsList = (response) => {
    let assets = response?.data?.assets ?? [];
    dispatch({ type: GET_ASSETS_LIST, payload: assets });
  };

  const setSubmitted = (response) => {
    console.log("set submitted response", response);
    dispatch({ type: SET_SUBMITTED, payload: response });
  };

  const getPageResult = (data) => {
    const { response, id } = data;
    const query = new URLSearchParams(search);
    const pageId = query.get("pageId");
    if (!pageId || (pageId && pageId !== id)) return;
    dispatch({ type: SET_PAGE, payload: response?.data?.[0]?.[0] });
  };

  const handlePageEot = (socket, topic, response) => {
    const topicSegments = topic.split("/");
    if (response.data && response.data.length > 0) {
      if (topicSegments?.[3] === "page") {
        const pageId = topicSegments[4];
        const query = new URLSearchParams(search);
        const connectionId = query.get("connectionId");
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getPageRequestPublishTopic(connectionId),
          wrapRequestPayload(
            {
              objectId: pageId,
              paths: ["$"],
              returnPaths: ["$"],
            },
            pageId
          )
        );
      } else if (topicSegments?.[3] === "user") {
        const userId = topicSegments[4];
        dispatch({
          type: PATCH_USER,
          payload: { userId, user: response?.data },
        });
      }
    }
  };

  const handleAppendMessage = (response) => {
    const resp = response.data;
    const message = {
      messageType:
        resp.message.attributes.eventSummarySubType || resp.message.type,
      createdAt: resp.pageInfo.publishedAt,
      data: resp.message.attributes,
      senderName: `user# ${resp.pageInfo.userId}`,
      senderId: resp.pageInfo.userId,
      message: resp.message.attributes.body,
      id: resp.pageInfo.pageMessageId.toString(),
      originalPageMessageId: resp?.pageInfo?.originalPageMessageId?.toString(),
      originalCreatedAt: resp?.pageInfo?.originalCreatedAt,
      refMessage: resp?.pageInfo?.refMessage,
      status: resp.message.attributes.eventSummaryStatus,
    };
    dispatch({ type: SET_CURRENT_MESSAGE, payload: message });
    const requestId = localStorage.getItem("requestId");
    if (requestId === "summary" && message.messageType === "text") return;
    dispatch({ type: APPEND_MESSAGE, payload: message });
  };

  const getUsersList = (id, response) => {
    const users = (response?.data ?? []).map((user: any) => {
      const id = Object.keys(user)?.[0];
      return {
        id,
        nonpersistent: {
          static: {
            live: {
              status: user?.[id]?.[0]?.[0],
            },
          },
        },
        firstName:
          user?.[id]?.[1]?.[0]?.profile?.firstName ??
          user?.[id]?.[1]?.[0].firstName,
        lastName:
          user?.[id]?.[1]?.[0]?.profile?.lastName ??
          user?.[id]?.[1]?.[0].lastName,
        fullName: `${
          user?.[id]?.[1]?.[0]?.profile?.firstName ??
          user?.[id]?.[1]?.[0].firstName
        } ${
          user?.[id]?.[1]?.[0]?.profile?.lastName ??
          user?.[id]?.[1]?.[0].lastName
        }`,
        email:
          user?.[id]?.[1]?.[0]?.alternativeIds?.email ??
          user?.[id]?.[1]?.[0].email,
        phone:
          user?.[id]?.[1]?.[0]?.alternativeIds?.phone ??
          user?.[id]?.[1]?.[0].phoneNumber,
        admin: user?.[id]?.[2]?.[0],
      };
    });
    dispatch({ type: SET_USERS, payload: users });
    dispatch({ type: "SET_USERS_REQUEST_ID", payload: { users, id } });
  };

  const handleMessages = (id, response) => {
    console.log("response", response);
    let messages = response;
    let updatedMessages = [];
    if (!Array.isArray(messages)) return;
    messages =
      messages?.map((message) => {
        return message.object;
      }) ?? [];
    for (let message of messages) {
      message = {
        messageType:
          message.message.attributes.eventSummarySubType ||
          message.message.type,
        createdAt: message.pageInfo.createdAt,
        data: message.message.attributes,
        senderName: `user# ${message.pageInfo.userId}`,
        senderId: message.pageInfo.userId,
        message: message.message.attributes.body,
        id: message.pageInfo.pageMessageId.toString(),
        originalPageMessageId:
          message?.pageInfo?.originalPageMessageId?.toString(),
        originalCreatedAt: message?.pageInfo?.originalCreatedAt,
        refMessage: message?.pageInfo?.refMessage,
        status: message.message.attributes.eventSummaryStatus,
      };
      updatedMessages.push(message);
    }
    const requestId = localStorage.getItem("requestId");
    const requestService = localStorage.getItem("requestService");
    if (requestId === id) {
      if (requestService === "summary") {
        updatedMessages = updatedMessages.filter((message) => {
          return (
            message.messageType !== "text" &&
            message.messageType !== "info" &&
            message.messageType !== "log"
          );
        });
      }
      updatedMessages.reverse();
      dispatch({ type: SET_MESSAGES, payload: updatedMessages });
    }
  };

  const handleUserBds = (payload) => {
    const response = payload?.response;
    dispatch({ type: "USER_BDS", payload: response.data });
  };

  const handleAdminUser = (payload) => {
    const response = payload?.response;
    dispatch({ type: "ADMIN_USER", payload: response.data });
  };

  const handleAggregateBds = (payload) => {
    const response = payload?.response;
    dispatch({ type: "AGGREGATE_BDS", payload: response.data });
  };

  const handlePageResults = (payload) => {
    const requestId = localStorage.getItem("pageRequestId");
    if (requestId !== payload?.id) {
      return;
    }

    console.log("payload", payload);

    const response = payload?.response;
    const data = response?.data;
    try {
      let organizedData =
        data?.map(
          (page) =>
            page[Object.keys(page)[0]][0][0] && {
              pageId: Object.keys(page)[0],
              memberActive:
                !page[Object.keys(page)[0]][0][0]?.persistent.static.metadata
                  ?.members?.users?.[localStorage.getItem("RID")]?.pending,
              ...page[Object.keys(page)[0]][0][0],
            }
        ) ?? [];

      const filteredData = organizedData
        .filter((data) => data)
        .sort(
          (a, b) =>
            (moment(
              b.lastSent?.updatedAt ?? b.persistent.static.metadata.createdAt
            ) as any) -
            (moment(
              a.lastSent?.updatedAt ?? a.persistent.static.metadata.createdAt
            ) as any)
        );
      if (filteredData) {
        dispatch({ type: "SET_PAGE_RESULT", payload: filteredData });
      }
    } catch (e) {
      console.error("failed to fetch pages", e);
    }
  };

  const handleAggregate = (payload) => {
    const id = payload.id;
    if (!payload?.response?.data?.[0]?.id) return;
    const users = (payload?.response?.data ?? []).map((user: any) => {
      const id = user.id.toString();
      return {
        id,
        nonpersistent: {
          static: {
            live: {
              status: user.status,
            },
          },
        },
        firstName: user?.live?.profile?.firstName,
        lastName: user?.live?.profile?.lastName,
        fullName: `${user?.live?.profile?.firstName} ${user?.live?.profile?.lastName}`,
        beamId: user?.live?.beamIds?.[0],
        email: user?.live?.alternativeIds?.email,
        phone: user?.live?.alternativeIds?.phone,
        admin: user?.admin,
      };
    });
    dispatch({ type: SET_USERS, payload: users });
    dispatch({ type: "SET_USERS_REQUEST_ID", payload: { users, id } });
  };

  return {
    handleAggregateBds,
    handleAggregate,
    handlePageResults,
    getUserRequestPayload,
    handleAdminUser,
    getSurveyList,
    getSectionList,
    getBio,
    getRoleList,
    updateUserRequestPayload,
    updateUserRequestPayloadV2,
    getExtendedBioList,
    getVehicleExtendedBioList,
    getProjectList,
    getRespondersList,
    getAssetsList,
    setSubmitted,
    getPageResult,
    handlePageEot,
    getUsersList,
    handleMessages,
    handleAppendMessage,
    handleUserBds,
    getAccountsList,
  };
};
